import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import EndpointsCommon from '../../../app/helpers/endpoints-common';
import templateMarkup from 'raw-loader!./endpoint-form.html';
import TranslationService from '../../../services/translation.service';
import '../../../app/bindings/ko-bindinghandler-tokenfield';
// import 'knockout.validation';

function UpdateEndpointModal(params) {
    let self = this;
    self.signals = ko.unwrap(params.signals);

    if (!_.has(self, 'signals.onShow') || !_.has(self, 'signals.onSave')) {
        throw new Error('UpdateEndpointModal:: Missing required signals: show, save');
    }
    params.showSave(true);

    // ko.validation.init({
    //     registerExtenders: true,
    //     messagesOnModified: true,
    //     insertMessages: true,
    //     parseInputAttributes: true,
    //     messageTemplate: null,
    //     grouping: {
    //         deep: true,
    //         observable: true,
    //         live: false
    //     }
    // }, true);
    //
    // ko.validation.rules.pattern.message = 'Invalid entry';

    this.translationService = new TranslationService();
    this.model = initializeModel();
    
    // this.priceValidation = ko.pureComputed(function () {
    //     return ko.utils.validationMessage(this.model.price);
    // });
    // this.priceError = ko.pureComputed(function () {
    //     return ko.utils.hasError(this.model.price);
    // });
    this.updateModel(params.model);

    this.meta = {
        singleMode: ko.pureComputed(isSingleMode.bind(null, this.model)),
        itemsCount: ko.pureComputed(itemsCount.bind(null, this.model)),
        hasTMSTags: ko.pureComputed(function () {
            return !_.isEmpty(this.model.tmsTag());
        }.bind(this))
    };
    this.signalListeners = {
        onShow: this.show.bind(this),
        onSave: this.save.bind(this)
    };
    this.signals.onShow.add(this.signalListeners.onShow);
    this.signals.onSave.add(this.signalListeners.onSave);

    params.enableSave(!this.model.price.hasError.regex());

    this.subscriptions = [
      this.model.price.hasError.regex.subscribe(_.bind(function() {
            params.enableSave(!this.model.price.hasError.regex());
        }, this))
    ];
}

function initializeModel() {
    return {
        ids: ko.observableArray(),
        id: ko.observable(),
        altName: ko.observable(),
        description: ko.observable(),
        location: ko.observable(),
        price: ko.observable().extend({
            regex: {
                message: 'Invalid price format. Use whole numbers. Thousands can be separated by commas.',
                pattern: /(?=.)^(([1-9][0-9]{0,2}(,[0-9]{3})*)|[0-9]+)?$/
            }
        }),
        tags: ko.observableArray(),
        tmsTag: ko.observableArray()
    };
}

UpdateEndpointModal.prototype.updateModel = function (inputModel) {
    inputModel = ko.unwrap(inputModel);
    var id;
    var ids;

    if (_.isEmpty(inputModel.ids)) {
        id = inputModel.id;
    } else {
        ids = inputModel.ids;
    }
    this.model.ids(ids);
    this.model.id(id);
    this.model.altName(_.trim(inputModel.altName));
    this.model.description(_.trim(inputModel.description));
    this.model.location(_.trim(inputModel.location));
    this.model.price(_.trim(inputModel.price));
    this.model.tags(EndpointsCommon.tagsRawToToken(inputModel.tags || []));
    this.model.tmsTag(EndpointsCommon.tagsRawToToken(inputModel.tmsTag || []));
};

UpdateEndpointModal.prototype.show = function (model) {
    if (_.isEmpty(model.ids) && _.isEmpty(model.id)) {
        throw new Error('UpdateEndpointModal needs an endpoint model with an id or a list of ids.');
    }
    this.updateModel(model);
};

UpdateEndpointModal.prototype.save = function () {
    var updatedModel = ko.toJS(this.model);
    return this.signals.onSaveCallback.dispatch(updatedModel);
};

function isSingleMode(model) {
    return itemsCount(model) <= 1;
}

function itemsCount(model) {
    return !ko.unwrap(model.ids) ? 0 : ko.unwrap(model.ids).length;
}

UpdateEndpointModal.prototype.dispose = function () {
    this.signals.onShow.remove(this.signalListeners.onShow);
    this.signals.onSave.remove(this.signalListeners.onSave);
    delete this.signalListeners;

    _.forEach(this.subscriptions, function(sub) {
        sub.dispose();
    });
};

export default {
    viewModel: UpdateEndpointModal,
    template: templateMarkup
};
